import axios from "axios";
import { AuthModule } from "../../src/store/modules/auth.module";
import { APP_API_ROOT_URL } from "./config";
import { toaster } from "../utilities/toaster";
import router from "../router/index";
const service = axios.create({
    baseURL: APP_API_ROOT_URL,
});
service.interceptors.request.use(async (config) => {
    if (config.url != "UserRegistration") {
        const expiresOn = AuthModule.expiredOn;
        const diffInMilliseconds = expiresOn.getTime() - new Date().getTime();
        const expiresInMinutes = Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000);
        if (expiresInMinutes <= 0) {
            await AuthModule.SessionTimeout();
        }
        if (expiresInMinutes <= 10) {
            await AuthModule.LoginSilent();
        }
        if (AuthModule.isAuthenticated && AuthModule.accessToken) {
            const accessToken = AuthModule.accessToken;
            config.headers["Authorization"] = `Bearer ${accessToken}`;
        }
    }
    return config;
}, (error) => {
    router.push({ path: "sessiontimeout" });
    Promise.reject(error);
});
service.interceptors.response.use((response) => {
    // debugger;
    return response;
}, function (error) {
    if (error.response && (error.response.status === 400 || error.response.status === 500)) {
        // debugger;
        console.log(error.response.data);
        if (error.response.data) {
            toaster.ShowApiError(error.response.data);
        }
    }
    return Promise.reject(error.response.data);
});
export default service;
